import { CREATE_VEHICLE, GET_VEHICLE, VEHICLE_REQUEST, DELETE_VEHICLE, UPDATE_VEHICLE, VEHICLE_REQUEST_FAILURE } from "../types";

const initialState = {
  vehicles: [],
  loading: false,
  error: null,
};

const vehicleReducer = (state = initialState, action) => {
  switch (action.type) {
    case VEHICLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_VEHICLE: {
      return {
        ...state,
        vehicles: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_VEHICLE:
      console.log('<<action---', action.payload)
      return {
        ...state,
        vehicles: [action.payload, ...state.vehicles],
        loading: false,
        error: null
      };
    case UPDATE_VEHICLE:
      const vehiclesData = state.vehicles.slice(0);
      const uIndex = vehiclesData.findIndex((data) => data.id === action.payload.id);
      vehiclesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        vehicles: [ ...vehiclesData ],
        loading: false,
        error: null
      };
    case DELETE_VEHICLE:
      const vehicles = state.vehicles?.slice(0);
      const index = vehicles.findIndex((data) => data.id === action.id);
      if (index > -1) {
          vehicles.splice(index, 1);
      }
      return {
        ...state,
        vehicles: [...vehicles],
        loading: false,
        error: null
      }
    case VEHICLE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default vehicleReducer;